// Progressive evidence tooltip: hover / focus / tap. position:fixed so a
// scrolling table cannot clip the panel. Works without the island React tree.

const GAP = 8;
const HOVER_OPEN_MS = 180;
const HOVER_CLOSE_MS = 120;

let openTip = null;
let openTimer = 0;
let closeTimer = 0;

function panelOf(button) {
  const id = button.getAttribute("aria-controls");
  return id ? document.getElementById(id) : null;
}

function hide(button) {
  if (!button) return;
  const panel = panelOf(button);
  button.setAttribute("aria-expanded", "false");
  if (panel) panel.hidden = true;
  if (openTip === button) openTip = null;
}

function place(button, panel) {
  const rect = button.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  panel.style.visibility = "hidden";
  panel.hidden = false;
  const pw = Math.min(panel.offsetWidth || 320, vw - GAP * 2);
  panel.style.maxWidth = `${pw}px`;
  panel.style.maxHeight = `${Math.max(120, vh - GAP * 2)}px`;
  const width = panel.offsetWidth;
  const height = panel.offsetHeight;
  let top = rect.bottom + GAP;
  if (top + height > vh - GAP && rect.top - GAP - height >= GAP) {
    top = rect.top - GAP - height;
  }
  top = Math.min(Math.max(GAP, top), Math.max(GAP, vh - height - GAP));
  let left = rect.left + rect.width / 2 - width / 2;
  left = Math.min(Math.max(GAP, left), Math.max(GAP, vw - width - GAP));
  panel.style.top = `${Math.round(top)}px`;
  panel.style.left = `${Math.round(left)}px`;
  panel.style.visibility = "";
}

function show(button) {
  const panel = panelOf(button);
  if (!panel) return;
  if (openTip && openTip !== button) hide(openTip);
  button.setAttribute("aria-expanded", "true");
  place(button, panel);
  openTip = button;
}

function cancelTimers() {
  window.clearTimeout(openTimer);
  window.clearTimeout(closeTimer);
  openTimer = 0;
  closeTimer = 0;
}

function scheduleOpen(button) {
  cancelTimers();
  openTimer = window.setTimeout(() => show(button), HOVER_OPEN_MS);
}

function scheduleClose(button) {
  cancelTimers();
  closeTimer = window.setTimeout(() => hide(button), HOVER_CLOSE_MS);
}

function related(event, button) {
  const panel = panelOf(button);
  const next = event.relatedTarget;
  return Boolean(next && (button.contains(next) || panel?.contains(next)));
}

export function enhanceEvidenceTips() {
  const buttons = document.querySelectorAll(".evidence-tip");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (button.dataset.bound) return;
    button.dataset.bound = "1";
    const panel = panelOf(button);
    if (!panel) return;

    button.addEventListener("pointerenter", () => scheduleOpen(button));
    button.addEventListener("pointerleave", (event) => {
      if (!related(event, button)) scheduleClose(button);
    });
    panel.addEventListener("pointerenter", () => cancelTimers());
    panel.addEventListener("pointerleave", (event) => {
      if (!related(event, button)) scheduleClose(button);
    });
    button.addEventListener("focus", () => show(button));
    button.addEventListener("blur", (event) => {
      if (!related(event, button)) hide(button);
    });
    button.addEventListener("click", (event) => {
      event.preventDefault();
      if (openTip === button) hide(button);
      else show(button);
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && openTip) {
      const button = openTip;
      hide(button);
      button.focus();
    }
  });
  document.addEventListener("pointerdown", (event) => {
    if (!openTip) return;
    const panel = panelOf(openTip);
    if (openTip.contains(event.target) || panel?.contains(event.target)) return;
    hide(openTip);
  });
  window.addEventListener("resize", () => {
    if (openTip) {
      const panel = panelOf(openTip);
      if (panel && !panel.hidden) place(openTip, panel);
    }
  });
  window.addEventListener("scroll", () => {
    if (openTip) {
      const panel = panelOf(openTip);
      if (panel && !panel.hidden) place(openTip, panel);
    }
  }, true);
}
